module.exports = __webpack_public_path__ + "static/media/view leave by staff.725a64e4.svg";